import { render } from "./Vexe.vue?vue&type=template&id=2229c78f&scoped=true&lang=true"
import script from "./Vexe.vue?vue&type=script&lang=js"
export * from "./Vexe.vue?vue&type=script&lang=js"

import "./Vexe.vue?vue&type=style&index=0&id=2229c78f&lang=css&scoped=true"

import exportComponent from "/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2229c78f"]])

export default __exports__